import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as vaultSelectors from '@app/root-store/vault-store/vault.selector';
import { MY_FORMATS } from '@app/shared/component/accessibility-settings/accessibility-settings.component';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { OnboardingFormNotesWidgetComponent } from './onboarding-form-notes-widget/onboarding-form-notes-widget.component';
import { DocumentService } from '@app/shared/services';
import { error } from 'console';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { OnboardingFormNameWidgetComponent } from './onboarding-form-name-widget/onboarding-form-name-widget.component';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'form-preview-setup-with-notes',
  templateUrl: './form-preview-setup-with-notes.component.html',
  styleUrls: ['./form-preview-setup-with-notes.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormPreviewSetupWithNotesComponent implements OnInit, OnDestroy {
  @ViewChild(OnboardingFormNotesWidgetComponent, { static: true }) child: OnboardingFormNotesWidgetComponent;
  @ViewChild('OnboardingFormNameWidget', { static: false }) OnboardingFormNameWidget: OnboardingFormNameWidgetComponent;
  @Output() updateDbFun = new EventEmitter<any>();
  @Output() parentFun = new EventEmitter<any>();
  @Output() enableSaveFun = new EventEmitter<any>();
  @Input() JsonDataExtractedData;
  @Input() data;
  @Input() currentuserId;
  @Input() form_name;

  note;
  reminderList = [];
  currentStep = 0;

  @Input() fId;
  insurance_attributes = [];
  documentForm: UntypedFormGroup;
  Form1;
  disablesingleFielFormValidator = false;
  subscription: Subscription = new Subscription();
  arrayItems;
  setupList = [];

  constructor(
    private store: Store,
    private toast: ToastrService,
    private formBuilder: UntypedFormBuilder,
    private documentService: DocumentService,
    private cd: ChangeDetectorRef
  ) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  ngOnInit(): void {
    // this.setupList.unshift({ type: 'general', params: null });
    // this.setupList.push({ type: 'notes', params: null });
    // this.setupList.map((x) => {
    //   return {
    //     x,
    //     is_active: false,
    //     answer: '',
    //     status: 'start',
    //     id: -1,
    //   };
    // });
    this.documentForm = this.formBuilder.group(
      {
        dynamicFieldsForm: new UntypedFormArray([]),
      },
      {
        validators: [this.relationshipTypeThreeConditionallyRequiredValidator.bind(this)],
      }
    );
    this.getFormById();
    this.subscription.add(
      this.documentService.getReminderList(this.data.user_id, this.data.vault_user_form_id, true).subscribe((res) => {
        if (res) {
          this.reminderList = res.filter((x) => x.origin == 'maintenance');
          this.cd.detectChanges();
        }
      })
    );
  }
  bindAnswer(event) {
    this.setupList[event.index].answer = event.note;
  }
  getFormById() {
    this.subscription.add(
      this.store.select(vaultSelectors.getCurrentFormsById(this.fId)).subscribe((response) => {
        this.Form1 = response.template;
        this.insurance_attributes = response.insurance_attributes;
        this.setupList.push({ type: 'name', params: null, label: 'Document Name' });
        this.setupList.push({ type: 'general', params: null, label: 'General Information' });

        // if (response?.financial_attributes) {
        //   this.setupList.push({ type: 'financial', params: ['has_premium'] });
        // }
        // try {
        //   if (response.insurance_attributes?.length) {
        //     let insurance_attributesArray = response.insurance_attributes?.split(',');
        //     if (insurance_attributesArray.length > 0) {
        //       this.setupList.push({ type: 'insurance', params: null });
        //     }
        //   }
        // } catch (error) {}

        this.setupList.push({ type: 'notes', params: null, label: 'Additional Notes' });
        this.setupList.map((x) => {
          return {
            x,
            is_active: false,
            answer: '',
            status: 'start',
            id: -1,
          };
        });
        this.bindDataToForm();
        this.cd.detectChanges();
      })
    );
  }
  previousReminder() {
    if (this.currentStep == 0) {
    } else {
      this.currentStep = this.currentStep - 1;
    }
    this.cd.detectChanges();
  }
  nextReminder() {
    if (this.setupList[this.currentStep].type == 'name') {
      this.subscription.add(
        this.documentService
          .saveFormNameInDb({
            form_name: this.OnboardingFormNameWidget.form_name,
            id: this.data.vault_user_form_id,
            user_id: this.data.user_id,
          })
          .subscribe(
            (res) => {
              this.updateDbFun.emit();
              this.currentStep = this.currentStep + 1;
              this.cd.detectChanges();
            },
            (error) => {}
          )
      );
    } else if (this.setupList[this.currentStep].type == 'general') {
      this.enableSave();
    } else if (this.setupList[this.currentStep].type == 'notes') {
      this.saveNote(this.currentStep);
    } else {
      this.currentStep = this.currentStep + 1;
    }

    this.enableSaveFun.emit(this.currentStep == this.setupList.length - 1 ? true : false);
  }
  bindDataToForm() {
    this.arrayItems = [];
    this.arrayItems = this.Form1[0]['singleFieldForm'];
    this.t.clear();
    const test = this.formBuilder.group({});
    this.arrayItems.forEach(function (value) {
      if (value['type'] === 'MultiPleDropDown') {
        test.addControl(value.formControlName, new UntypedFormControl(''));
        value['data'].forEach((childcontrols) => {
          childcontrols['template'].forEach((child) => {
            test.addControl(child.formControlName, new UntypedFormControl(''));
          });
        });
      } else if (value['type'] === 'Section') {
      } else if (value['type'] == 'email') {
        test.addControl(value.formControlName, new UntypedFormControl(''));
      } else {
        test.addControl(value.formControlName, new UntypedFormControl(''));
      }
    });
    this.t.push(test);
    this.setDataFromAIResponse();
  }
  // convenience getters for easy access to form fields
  get f() {
    return this.documentForm.controls;
  }

  get t() {
    return this.f.dynamicFieldsForm as UntypedFormArray;
  }

  enableSave() {
    this.parentFun.emit(this.documentForm.value);
    this.updateReminderList(this.documentForm.value);
    this.currentStep = this.currentStep + 1;
    this.enableSaveFun.emit(this.currentStep == this.setupList.length - 1 ? true : false);
    this.cd.detectChanges();
  }
  updateReminderList(data) {
    this.reminderList.forEach((element, index) => {
      let depend_field_template = this.Form1[0].singleFieldForm.find((x) => x.triggerType == element.type);
      if (depend_field_template?.formControlName) {
        let formControlName = depend_field_template?.formControlName;
        let formEffectiveData =
          data.dynamicFieldsForm[0][formControlName] && data.dynamicFieldsForm[0][formControlName] != 'Invalid Date'
            ? data.dynamicFieldsForm[0][formControlName]
            : new Date('1970-1-1');
        let eDate = new Date(formEffectiveData);
        let fData = new Date(element.depend_on_date);
        if (eDate.getDate() != fData.getDate() || eDate.getMonth() != fData.getMonth() || eDate.getFullYear() != fData.getFullYear()) {
          element.depend_on_date = eDate;
          if (element['depend_on_date']) {
            let date = new Date(element['depend_on_date']);
            element['depend_on_date'] = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
          } else {
            element['depend_on_date'] = null;
          }
          let new_date;
          if (element.period == 'day') {
            if (element.remind_when == 'before') {
              new_date = moment(eDate, 'DD-MM-YYYY').add(-+element.duration, 'days');
            } else {
              new_date = moment(eDate, 'DD-MM-YYYY').add(+element.duration, 'days');
            }
          } else if (element.period == 'month' || element.period == 'months') {
            if (element.remind_when == 'before') {
              new_date = moment(eDate, 'DD-MM-YYYY').add(-+element.duration, 'M');
            } else {
              new_date = moment(eDate, 'DD-MM-YYYY').add(+element.duration, 'M');
            }
          } else {
            if (element.remind_when == 'before') {
              new_date = moment(eDate, 'DD-MM-YYYY').add(-+element.duration, 'y');
            } else {
              new_date = moment(eDate, 'DD-MM-YYYY').add(+element.duration, 'y');
            }
          }
          element.effective_date = new_date;
        }
        this.saveAllReminderList(element);
      }
    });
  }
  saveAllReminderList(element) {
    if (element?.effective_date) {
      let date = new Date(element['effective_date']);
      element.effective_date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    }
    if (element?.depend_on_date) {
      let date = new Date(element['depend_on_date']);
      element.depend_on_date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    }
    const data = {
      user_id: this.data.user_id,
      form_id: this.data.vault_user_form_id,
      data: [element],
    };
    this.subscription.add(this.documentService.updateReminderList(data).subscribe((res) => {}));
  }

  setDataFromAIResponse() {
    Object.entries(this.JsonDataExtractedData).forEach(([key, value]) => {
      let findIndex =
        this.arrayItems.findIndex((x) => x.label.trim() == key) != -1
          ? this.arrayItems.findIndex((x) => x.label.trim() == key)
          : this.arrayItems.findIndex((x) => x.formControlName.trim() == key);
      if (findIndex > 0) {
        try {
          if (this.arrayItems[findIndex].type == 'date') {
            this.documentForm.controls.dynamicFieldsForm['controls'][0].controls[this.arrayItems[findIndex].formControlName].setValue(
              new Date(value.toString())
            );
          } else {
            this.documentForm.controls.dynamicFieldsForm['controls'][0].controls[this.arrayItems[findIndex].formControlName].setValue(value);
          }
        } catch (error) {}
      }
    });
    this.cd.detectChanges();
  }
  saveNote(index) {
    if (this.setupList[index].answer == undefined || this.setupList[index].answer == null || this.setupList[index].answer?.length == 0) {
      return;
    }
    let payload = {
      note: this.setupList[index].answer,
      title: this.setupList[index]?.label ?? '',
      vault_user_form_id: this.data.vault_user_form_id,
      id: this.setupList[index].id,
    };
    if (this.setupList[index].id == -1) {
      delete payload['id'];
    }
    this.subscription.add(
      this.documentService.createNote(payload).subscribe(
        (res) => {
          this.setupList[index].id = res.data.id;
          // this.toast.success('Note added');
          this.currentStep = this.currentStep + 1;
          this.enableSaveFun.emit(this.currentStep == this.setupList.length - 1 ? true : false);
        },
        (error) => {
          this.toast.error('Error adding Note added');
        }
      )
    );
  }
  clickNt(index) {
    try {
      let newArrayItemList = [];
      this.arrayItems.forEach((element, currentIndex) => {
        let objCopy = { ...element };
        if (currentIndex == index) {
          objCopy.setDefaultEyeField = !objCopy.setDefaultEyeField;
        }
        newArrayItemList.push(objCopy);
      });
      this.arrayItems = newArrayItemList;
      this.cd.detectChanges();
    } catch (error) {
      console.error('**', error);
    }
  }
  relationshipTypeThreeConditionallyRequiredValidator(formGroup: UntypedFormGroup) {
    if (formGroup.controls.dynamicFieldsForm['controls'].length > 0) {
      const data = Object.keys(formGroup.controls.dynamicFieldsForm['controls'][0].value);
      const formValue = this.Form1[0]['singleFieldForm'];
      this.disablesingleFielFormValidator = false;
      data.forEach((element) => {
        const data = formGroup.controls.dynamicFieldsForm['controls'][0]['value'][element];
        const currentFOrm = formValue.find((obj) => obj.formControlName == element);
        if (formValue.findIndex((obj) => obj.formControlName == element) != -1) {
          if (currentFOrm['type'] == 'email') {
            const mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if (data != '' && !mailformat.test(data)) {
              this.disablesingleFielFormValidator = true;
              return { invalidCustom: true };
            }
          }
          if (currentFOrm['isRequired']) {
            if (data == '') {
              this.disablesingleFielFormValidator = true;
              return { invalidCustom: true };
            }
          }
        } else {
          const AllMultiDropDownList = formValue.filter((obj) => obj.type == 'MultiPleDropDown');
          let dropDownList = [];
          AllMultiDropDownList.forEach((multidropDownList) => {
            multidropDownList['data'].forEach((list) => {
              dropDownList = dropDownList.concat(list['template']);
            });
          });
          const data = formGroup.controls.dynamicFieldsForm['controls'][0]['value'][element];
          if (dropDownList.findIndex((obj) => obj.formControlName == element) != -1) {
            const currentFOrm = dropDownList.find((obj) => obj.formControlName == element);
            const parentformDat = formGroup.controls.dynamicFieldsForm['controls'][0]['value'][currentFOrm['parentformControlName']];
            if (parentformDat == currentFOrm['parentformControlValue']) {
              if (currentFOrm['type'] == 'email') {
                const mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                if (data != '' && !mailformat.test(data)) {
                  this.disablesingleFielFormValidator = true;
                  return { invalidCustom: true };
                }
              }
              if (currentFOrm['isRequired']) {
                if (data == '') {
                  this.disablesingleFielFormValidator = true;
                  return { invalidCustom: true };
                }
              }
            }
          }
        }
      });
      return null;
    }
  }
}
